import React from "react";
import IDS from "../../IDS";
import { Component } from "../../Component";
import "../../common.css";
import "./Spacer1.css";

class Spacer1 extends Component {
    ID = IDS.SPACER1;
    static Default() {
        return new Spacer1();
    }
    static fromJSON(data) {
        return new Spacer1();
    }
}

const Spacer1View = ({ data = Spacer1.Default() }) => {
    return (
        <div className="Spacer1--Large">
        </div>
    )
}


export {
    Spacer1,
    Spacer1View,
}